import { OperationBatchStatus } from "@wallet-manager/node-types/dist/src/postgres/const";

export const completedBatchStatuses = [
  OperationBatchStatus.Completed,
  OperationBatchStatus.PartialCompleted,
  OperationBatchStatus.Failed,
  OperationBatchStatus.SignFailed,
  OperationBatchStatus.Rejected,
];
